import './SearchSuggestionList.css';

function SearchSuggestionList(props) {
  return (
    <div class="search__suggestion-list">
      {props.suggestions.map((elem, i) => {
        // limit to 5 suggestions showing up
        if (i >= 5) {
          return null;
        }
        return <div class="search__suggestion-item">{elem["conjugation"]}</div>
      })}
    </div>
  );
}

export default SearchSuggestionList;
